import { defineMessages } from 'react-intl';

const messages = defineMessages({
  authorizeSignatureTitle: {
    id: 'App.RentForecast.AuthorizeSignature.Title',
    defaultMessage: 'Add Signature',
  },
  reportSignatureLabel: {
    id: 'App.RentForecast.AuthorizeSignature.Report.Signature.Label',
    defaultMessage: 'Your Signature',
  },
  reportInputLabel: {
    id: 'App.RentForecast.AuthorizeSignature.Report.Printed.Label',
    defaultMessage: 'Printed Name',
  },
  reportInputHelper: {
    id: 'App.RentForecast.AuthorizeSignature.Report.Printed.Helper',
    defaultMessage: 'As it should appear on final document',
  },
  residentLetterLabel: {
    id: 'App.RentForecast.AuthorizeSignature.Letter.Toggle.Label',
    defaultMessage: 'Signature',
  },
  residentLetterReport: {
    id: 'App.RentForecast.AuthorizeSignature.Letter.Report.Checkbox',
    defaultMessage: 'Use the same signature as 3560-7',
  },
  saveSuccess: {
    id: 'App.RentForecast.AuthorizeSignature.Submit.Success',
    defaultMessage: 'Signature data successfully stored.',
  },
  saveFailed: {
    id: 'App.RentForecast.AuthorizeSignature.Submit.Failed',
    defaultMessage: 'Could not store signature data.',
  },
});

export default messages;
